// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/custom_field_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { CompanyOrEngagement } from "./entity_pb";
import { file_inventory_v1_entity } from "./entity_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/custom_field_service.proto.
 */
export const file_inventory_v1_custom_field_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_inventory_v1_entity]);

/**
 * @generated from message inventory.v1.CreateCustomFieldRequest
 */
export type CreateCustomFieldRequest = Message<"inventory.v1.CreateCustomFieldRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: inventory.v1.CustomFieldType type = 2;
   */
  type: CustomFieldType;

  /**
   * @generated from field: inventory.v1.CustomFieldEdgeType edge_type = 3;
   */
  edgeType: CustomFieldEdgeType;
};

/**
 * Describes the message inventory.v1.CreateCustomFieldRequest.
 * Use `create(CreateCustomFieldRequestSchema)` to create a new message.
 */
export const CreateCustomFieldRequestSchema: GenMessage<CreateCustomFieldRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 0);

/**
 * @generated from message inventory.v1.CreateCustomFieldResponse
 */
export type CreateCustomFieldResponse = Message<"inventory.v1.CreateCustomFieldResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateCustomFieldResponse.
 * Use `create(CreateCustomFieldResponseSchema)` to create a new message.
 */
export const CreateCustomFieldResponseSchema: GenMessage<CreateCustomFieldResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 1);

/**
 * @generated from message inventory.v1.UpdateCustomFieldRequest
 */
export type UpdateCustomFieldRequest = Message<"inventory.v1.UpdateCustomFieldRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.UpdateCustomFieldRequest.
 * Use `create(UpdateCustomFieldRequestSchema)` to create a new message.
 */
export const UpdateCustomFieldRequestSchema: GenMessage<UpdateCustomFieldRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 2);

/**
 * @generated from message inventory.v1.UpdateCustomFieldResponse
 */
export type UpdateCustomFieldResponse = Message<"inventory.v1.UpdateCustomFieldResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateCustomFieldResponse.
 * Use `create(UpdateCustomFieldResponseSchema)` to create a new message.
 */
export const UpdateCustomFieldResponseSchema: GenMessage<UpdateCustomFieldResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 3);

/**
 * @generated from message inventory.v1.DeleteCustomFieldRequest
 */
export type DeleteCustomFieldRequest = Message<"inventory.v1.DeleteCustomFieldRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.DeleteCustomFieldRequest.
 * Use `create(DeleteCustomFieldRequestSchema)` to create a new message.
 */
export const DeleteCustomFieldRequestSchema: GenMessage<DeleteCustomFieldRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 4);

/**
 * @generated from message inventory.v1.DeleteCustomFieldResponse
 */
export type DeleteCustomFieldResponse = Message<"inventory.v1.DeleteCustomFieldResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteCustomFieldResponse.
 * Use `create(DeleteCustomFieldResponseSchema)` to create a new message.
 */
export const DeleteCustomFieldResponseSchema: GenMessage<DeleteCustomFieldResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 5);

/**
 * @generated from message inventory.v1.AddMultiSelectOptionRequest
 */
export type AddMultiSelectOptionRequest = Message<"inventory.v1.AddMultiSelectOptionRequest"> & {
  /**
   * @generated from field: string custom_field_id = 1;
   */
  customFieldId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.AddMultiSelectOptionRequest.
 * Use `create(AddMultiSelectOptionRequestSchema)` to create a new message.
 */
export const AddMultiSelectOptionRequestSchema: GenMessage<AddMultiSelectOptionRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 6);

/**
 * @generated from message inventory.v1.AddMultiSelectOptionResponse
 */
export type AddMultiSelectOptionResponse = Message<"inventory.v1.AddMultiSelectOptionResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.AddMultiSelectOptionResponse.
 * Use `create(AddMultiSelectOptionResponseSchema)` to create a new message.
 */
export const AddMultiSelectOptionResponseSchema: GenMessage<AddMultiSelectOptionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 7);

/**
 * @generated from message inventory.v1.DeleteMultiSelectOptionRequest
 */
export type DeleteMultiSelectOptionRequest = Message<"inventory.v1.DeleteMultiSelectOptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.DeleteMultiSelectOptionRequest.
 * Use `create(DeleteMultiSelectOptionRequestSchema)` to create a new message.
 */
export const DeleteMultiSelectOptionRequestSchema: GenMessage<DeleteMultiSelectOptionRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 8);

/**
 * @generated from message inventory.v1.DeleteMultiSelectOptionResponse
 */
export type DeleteMultiSelectOptionResponse = Message<"inventory.v1.DeleteMultiSelectOptionResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteMultiSelectOptionResponse.
 * Use `create(DeleteMultiSelectOptionResponseSchema)` to create a new message.
 */
export const DeleteMultiSelectOptionResponseSchema: GenMessage<DeleteMultiSelectOptionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 9);

/**
 * @generated from message inventory.v1.RenameMultiSelectOptionRequest
 */
export type RenameMultiSelectOptionRequest = Message<"inventory.v1.RenameMultiSelectOptionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.RenameMultiSelectOptionRequest.
 * Use `create(RenameMultiSelectOptionRequestSchema)` to create a new message.
 */
export const RenameMultiSelectOptionRequestSchema: GenMessage<RenameMultiSelectOptionRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 10);

/**
 * @generated from message inventory.v1.RenameMultiSelectOptionResponse
 */
export type RenameMultiSelectOptionResponse = Message<"inventory.v1.RenameMultiSelectOptionResponse"> & {
};

/**
 * Describes the message inventory.v1.RenameMultiSelectOptionResponse.
 * Use `create(RenameMultiSelectOptionResponseSchema)` to create a new message.
 */
export const RenameMultiSelectOptionResponseSchema: GenMessage<RenameMultiSelectOptionResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 11);

/**
 * @generated from message inventory.v1.ListCustomFieldsRequest
 */
export type ListCustomFieldsRequest = Message<"inventory.v1.ListCustomFieldsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListCustomFieldsRequest.
 * Use `create(ListCustomFieldsRequestSchema)` to create a new message.
 */
export const ListCustomFieldsRequestSchema: GenMessage<ListCustomFieldsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 12);

/**
 * @generated from message inventory.v1.ListCustomFieldsResponse
 */
export type ListCustomFieldsResponse = Message<"inventory.v1.ListCustomFieldsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.CustomField custom_fields = 1;
   */
  customFields: CustomField[];
};

/**
 * Describes the message inventory.v1.ListCustomFieldsResponse.
 * Use `create(ListCustomFieldsResponseSchema)` to create a new message.
 */
export const ListCustomFieldsResponseSchema: GenMessage<ListCustomFieldsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 13);

/**
 * @generated from message inventory.v1.CustomField
 */
export type CustomField = Message<"inventory.v1.CustomField"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: inventory.v1.CustomFieldType type = 3;
   */
  type: CustomFieldType;

  /**
   * @generated from field: inventory.v1.CustomFieldEdgeType edge_type = 4;
   */
  edgeType: CustomFieldEdgeType;
};

/**
 * Describes the message inventory.v1.CustomField.
 * Use `create(CustomFieldSchema)` to create a new message.
 */
export const CustomFieldSchema: GenMessage<CustomField> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 14);

/**
 * @generated from message inventory.v1.ListMultiSelectOptionsRequest
 */
export type ListMultiSelectOptionsRequest = Message<"inventory.v1.ListMultiSelectOptionsRequest"> & {
  /**
   * @generated from field: string custom_field_id = 1;
   */
  customFieldId: string;
};

/**
 * Describes the message inventory.v1.ListMultiSelectOptionsRequest.
 * Use `create(ListMultiSelectOptionsRequestSchema)` to create a new message.
 */
export const ListMultiSelectOptionsRequestSchema: GenMessage<ListMultiSelectOptionsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 15);

/**
 * @generated from message inventory.v1.ListMultiSelectOptionsResponse
 */
export type ListMultiSelectOptionsResponse = Message<"inventory.v1.ListMultiSelectOptionsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Option options = 1;
   */
  options: Option[];
};

/**
 * Describes the message inventory.v1.ListMultiSelectOptionsResponse.
 * Use `create(ListMultiSelectOptionsResponseSchema)` to create a new message.
 */
export const ListMultiSelectOptionsResponseSchema: GenMessage<ListMultiSelectOptionsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 16);

/**
 * @generated from message inventory.v1.AddMultiSelectOptionToEntityRequest
 */
export type AddMultiSelectOptionToEntityRequest = Message<"inventory.v1.AddMultiSelectOptionToEntityRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: string custom_field_id = 2;
   */
  customFieldId: string;

  /**
   * @generated from field: string option_id = 3;
   */
  optionId: string;
};

/**
 * Describes the message inventory.v1.AddMultiSelectOptionToEntityRequest.
 * Use `create(AddMultiSelectOptionToEntityRequestSchema)` to create a new message.
 */
export const AddMultiSelectOptionToEntityRequestSchema: GenMessage<AddMultiSelectOptionToEntityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 17);

/**
 * @generated from message inventory.v1.AddMultiSelectOptionToEntityResponse
 */
export type AddMultiSelectOptionToEntityResponse = Message<"inventory.v1.AddMultiSelectOptionToEntityResponse"> & {
};

/**
 * Describes the message inventory.v1.AddMultiSelectOptionToEntityResponse.
 * Use `create(AddMultiSelectOptionToEntityResponseSchema)` to create a new message.
 */
export const AddMultiSelectOptionToEntityResponseSchema: GenMessage<AddMultiSelectOptionToEntityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 18);

/**
 * @generated from message inventory.v1.RemoveMultiSelectOptionFromEntityRequest
 */
export type RemoveMultiSelectOptionFromEntityRequest = Message<"inventory.v1.RemoveMultiSelectOptionFromEntityRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: string custom_field_id = 2;
   */
  customFieldId: string;

  /**
   * @generated from field: string option_id = 3;
   */
  optionId: string;
};

/**
 * Describes the message inventory.v1.RemoveMultiSelectOptionFromEntityRequest.
 * Use `create(RemoveMultiSelectOptionFromEntityRequestSchema)` to create a new message.
 */
export const RemoveMultiSelectOptionFromEntityRequestSchema: GenMessage<RemoveMultiSelectOptionFromEntityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 19);

/**
 * @generated from message inventory.v1.RemoveMultiSelectOptionFromEntityResponse
 */
export type RemoveMultiSelectOptionFromEntityResponse = Message<"inventory.v1.RemoveMultiSelectOptionFromEntityResponse"> & {
};

/**
 * Describes the message inventory.v1.RemoveMultiSelectOptionFromEntityResponse.
 * Use `create(RemoveMultiSelectOptionFromEntityResponseSchema)` to create a new message.
 */
export const RemoveMultiSelectOptionFromEntityResponseSchema: GenMessage<RemoveMultiSelectOptionFromEntityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 20);

/**
 * @generated from message inventory.v1.UpdateFreeTextValueRequest
 */
export type UpdateFreeTextValueRequest = Message<"inventory.v1.UpdateFreeTextValueRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: string custom_field_id = 2;
   */
  customFieldId: string;

  /**
   * @generated from field: string value = 3;
   */
  value: string;
};

/**
 * Describes the message inventory.v1.UpdateFreeTextValueRequest.
 * Use `create(UpdateFreeTextValueRequestSchema)` to create a new message.
 */
export const UpdateFreeTextValueRequestSchema: GenMessage<UpdateFreeTextValueRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 21);

/**
 * @generated from message inventory.v1.UpdateFreeTextValueResponse
 */
export type UpdateFreeTextValueResponse = Message<"inventory.v1.UpdateFreeTextValueResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateFreeTextValueResponse.
 * Use `create(UpdateFreeTextValueResponseSchema)` to create a new message.
 */
export const UpdateFreeTextValueResponseSchema: GenMessage<UpdateFreeTextValueResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 22);

/**
 * @generated from message inventory.v1.UpdateDateValueRequest
 */
export type UpdateDateValueRequest = Message<"inventory.v1.UpdateDateValueRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: string custom_field_id = 2;
   */
  customFieldId: string;

  /**
   * If value is not set, the date will be cleared
   *
   * @generated from field: optional google.protobuf.Timestamp value = 3;
   */
  value?: Timestamp;
};

/**
 * Describes the message inventory.v1.UpdateDateValueRequest.
 * Use `create(UpdateDateValueRequestSchema)` to create a new message.
 */
export const UpdateDateValueRequestSchema: GenMessage<UpdateDateValueRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 23);

/**
 * @generated from message inventory.v1.UpdateDateValueResponse
 */
export type UpdateDateValueResponse = Message<"inventory.v1.UpdateDateValueResponse"> & {
};

/**
 * Describes the message inventory.v1.UpdateDateValueResponse.
 * Use `create(UpdateDateValueResponseSchema)` to create a new message.
 */
export const UpdateDateValueResponseSchema: GenMessage<UpdateDateValueResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 24);

/**
 * @generated from message inventory.v1.Option
 */
export type Option = Message<"inventory.v1.Option"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.Option.
 * Use `create(OptionSchema)` to create a new message.
 */
export const OptionSchema: GenMessage<Option> = /*@__PURE__*/
  messageDesc(file_inventory_v1_custom_field_service, 25);

/**
 * @generated from enum inventory.v1.CustomFieldType
 */
export enum CustomFieldType {
  /**
   * @generated from enum value: CUSTOM_FIELD_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOM_FIELD_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: CUSTOM_FIELD_TYPE_MULTI_SELECT = 2;
   */
  MULTI_SELECT = 2,

  /**
   * @generated from enum value: CUSTOM_FIELD_TYPE_DATE = 3;
   */
  DATE = 3,
}

/**
 * Describes the enum inventory.v1.CustomFieldType.
 */
export const CustomFieldTypeSchema: GenEnum<CustomFieldType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_custom_field_service, 0);

/**
 * @generated from enum inventory.v1.CustomFieldEdgeType
 */
export enum CustomFieldEdgeType {
  /**
   * @generated from enum value: CUSTOM_FIELD_EDGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOM_FIELD_EDGE_TYPE_ORG_COMPANY = 1;
   */
  ORG_COMPANY = 1,

  /**
   * @generated from enum value: CUSTOM_FIELD_EDGE_TYPE_ORG_COMPANY_ENGAGEMENT = 2;
   */
  ORG_COMPANY_ENGAGEMENT = 2,
}

/**
 * Describes the enum inventory.v1.CustomFieldEdgeType.
 */
export const CustomFieldEdgeTypeSchema: GenEnum<CustomFieldEdgeType> = /*@__PURE__*/
  enumDesc(file_inventory_v1_custom_field_service, 1);

/**
 * @generated from service inventory.v1.CustomFieldService
 */
export const CustomFieldService: GenService<{
  /**
   * Configuration
   *
   * @generated from rpc inventory.v1.CustomFieldService.CreateCustomField
   */
  createCustomField: {
    methodKind: "unary";
    input: typeof CreateCustomFieldRequestSchema;
    output: typeof CreateCustomFieldResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.UpdateCustomField
   */
  updateCustomField: {
    methodKind: "unary";
    input: typeof UpdateCustomFieldRequestSchema;
    output: typeof UpdateCustomFieldResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.DeleteCustomField
   */
  deleteCustomField: {
    methodKind: "unary";
    input: typeof DeleteCustomFieldRequestSchema;
    output: typeof DeleteCustomFieldResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.AddMultiSelectOption
   */
  addMultiSelectOption: {
    methodKind: "unary";
    input: typeof AddMultiSelectOptionRequestSchema;
    output: typeof AddMultiSelectOptionResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.DeleteMultiSelectOption
   */
  deleteMultiSelectOption: {
    methodKind: "unary";
    input: typeof DeleteMultiSelectOptionRequestSchema;
    output: typeof DeleteMultiSelectOptionResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.RenameMultiSelectOption
   */
  renameMultiSelectOption: {
    methodKind: "unary";
    input: typeof RenameMultiSelectOptionRequestSchema;
    output: typeof RenameMultiSelectOptionResponseSchema;
  },
  /**
   * Usage
   *
   * @generated from rpc inventory.v1.CustomFieldService.ListCustomFields
   */
  listCustomFields: {
    methodKind: "unary";
    input: typeof ListCustomFieldsRequestSchema;
    output: typeof ListCustomFieldsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.ListMultiSelectOptions
   */
  listMultiSelectOptions: {
    methodKind: "unary";
    input: typeof ListMultiSelectOptionsRequestSchema;
    output: typeof ListMultiSelectOptionsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.AddMultiSelectOptionToEntity
   */
  addMultiSelectOptionToEntity: {
    methodKind: "unary";
    input: typeof AddMultiSelectOptionToEntityRequestSchema;
    output: typeof AddMultiSelectOptionToEntityResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.RemoveMultiSelectOptionFromEntity
   */
  removeMultiSelectOptionFromEntity: {
    methodKind: "unary";
    input: typeof RemoveMultiSelectOptionFromEntityRequestSchema;
    output: typeof RemoveMultiSelectOptionFromEntityResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.UpdateFreeTextValue
   */
  updateFreeTextValue: {
    methodKind: "unary";
    input: typeof UpdateFreeTextValueRequestSchema;
    output: typeof UpdateFreeTextValueResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.CustomFieldService.UpdateDateValue
   */
  updateDateValue: {
    methodKind: "unary";
    input: typeof UpdateDateValueRequestSchema;
    output: typeof UpdateDateValueResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_custom_field_service, 0);

